import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { GenShippingAccount } from '../models/shipping-account.model';
import { GenLoadingEnum } from '../enums/loading.enum';

@Injectable({
  providedIn: 'root',
})
export class GenShippingAccountsService {
  private loading = new Subject<GenLoadingEnum>();
  loading$ = this.loading.asObservable();

  constructor(
    protected globalMessageService: GlobalMessageService,
    private httpClient: HttpClient,
    private occEndpoints: OccEndpointsService,
  ) { }

  getShippingAccounts(): Observable<GenShippingAccount[]> {
    this.loading.next(GenLoadingEnum.Loading);
    const url = `${this.occEndpoints.getBaseUrl()}/users/current/shipping-accounts?fields=DEFAULT`;
    return <Observable<GenShippingAccount[]>>this.httpClient.get(url).pipe(
      map((response: any): GenShippingAccount[] => response.shippingAccounts.filter((shippingAccounts:GenShippingAccount) => !shippingAccounts.generacShippingAccount)),
      catchError(res => {
        this.loading.next(GenLoadingEnum.Failed);
        res.error.errors
          .forEach((error: any) => {
            this.globalMessageService.add(
              error.message
                ? error.message
                : { key: 'httpHandlers.unknownIdentifier' },
              GlobalMessageType.MSG_TYPE_ERROR
            );
          });
        return throwError(() => res.error.errors[0]);
      }),
      finalize(() => this.loading.next(GenLoadingEnum.Loaded))
    );
  }
}
